module.exports = __webpack_public_path__ + "img/fn-goal-11.cc9a6b77.jpg";